export default {
  ACTIVE: true,
  NOT_ACTIVE: false,
};
